@let languageSignalValue = languageService.langSignal();
<mat-card appearance="outlined" class="table-card smw-table-container">
  @let tableDataValue = tableData();
  @if (tableDataValue) {
    @let parametersValue = parameters();
    <table width="100%" class="table smw-table" cellspacing="0" cellpadding="1">
      <tr class="table__title">
        <td align="center">{{ 'DATETIME.TIME' | translate }}</td>
        @for (parameter of parametersValue; track $index) {
          <td
            align="center"
            matTooltip="{{
              'PRODUCT.SMW.TABLE_PARAMETERS.' + parameter | translate
            }}"
            [ngStyle]="parameter === 'webcam' ? { width: '70px' } : {}">
            <!--<ng-container *ngTemplateOutlet="parameterIcon; context: {$implicit: parameter}"></ng-container>-->
            <ng-container appWmIcon [inputParameter]="parameter"></ng-container>
          </td>
        }
      </tr>
      <tr class="table__units">
        <td></td>
        @for (parameter of parametersValue; track $index) {
          <td
            align="center"
            matTooltip="{{
              'PRODUCT.SMW.TABLE_PARAMETERS.' + parameter | translate
            }}">
            {{ 'PRODUCT.SMW.UNITS.' + parameter | translate }}
          </td>
        }
      </tr>
      @for (smw of tableDataValue; track $index; let i = $index) {
        @if (i | isNewDay: tableDataValue) {
          <tr class="table__date-row">
            <td [attr.colspan]="parametersValue.length + 1">
              {{
                smw['dtg']
                  | datex: 'dddd DD.MM.YYYY' : undefined : languageSignalValue
              }}
            </td>
          </tr>
        }
        <tr class="table__content">
          <td align="center">
            <b>{{
              smw['dtg'] | datex: 'HH:mm' : undefined : languageSignalValue
            }}</b>
          </td>
          @for (parameter of parametersValue; track $index) {
            <ng-container
              *ngTemplateOutlet="
                smwValue;
                context: {
                  $implicit: { param: parameter, dataset: smw, index: i },
                }
              "></ng-container>
          }
        </tr>
      }
    </table>
  }
  <mat-paginator
    [showFirstLastButtons]="true"
    [length]="length()"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onChangePage($event)">
  </mat-paginator>
</mat-card>

<!-- Values -->
<ng-template #smwValue let-data>
  @let smwServiceGreenTableDesignValue = smwService.greenTableDesign();
  @switch (data.param) {
    @case ('webcam') {
      <td align="left">
        <div>
          @let webcamImageUrl =
            data.dataset['dtg'] | webcamImageUrl: webcamImages();
          @if (webcamImageUrl) {
            <img class="zoom" [src]="webcamImageUrl" valign="middle" />
          }
        </div>
      </td>
    }
    @case ('gmaAlarm') {
      <td align="center">
        <ng-container
          matTooltip="{{
            'PRODUCT.SMW.Alarm.' +
              smwService.gmaAlarmText[data.dataset[data.param]] | translate
          }}">
          @if (data.dataset[data.param]) {
            <div
              class="alarm-triangle"
              [ngStyle]="{
                borderBottomColor:
                  smwService.gmaAlarmColors[data.dataset[data.param]],
              }">
              <span>{{ data.dataset[data.param] }}</span>
            </div>
          } @else {
            --
          }
        </ng-container>
      </td>
    }
    @case (data.param === 'dd' || data.param === 'ddg' ? data.param : '') {
      <td [matTooltip]="data.dataset[data.param] | windrose | translate">
        @if (data.dataset[data.param]) {
          <div
            [ngStyle]="{
              transform: 'rotate(' + data.dataset[data.param] + 'deg)',
            }">
            <fa-icon [icon]="['far', 'long-arrow-down']"></fa-icon>
          </div>
        }
      </td>
    }
    @case (
      data.param === 'ff' ||
      data.param === 'ffg' ||
      data.param === 'fg' ||
      data.param === 'ss1' ||
      data.param === 'humidityIndex' ||
      data.param === 'inversionIndex'
        ? data.param
        : ''
    ) {
      <td [ngClass]="data.param | colorMappingPigeon: data.dataset[data.param]">
        {{ data.dataset[data.param] | round }}
      </td>
    }
    @case (
      data.param === 'ppp' ||
      data.param === 'qfe' ||
      data.param === 'rhxxx' ||
      data.param === 'hcl'
        ? data.param
        : ''
    ) {
      <td [ngClass]="data.param | colorMappingPigeon: data.dataset[data.param]">
        {{ data.dataset[data.param] | round }}
      </td>
    }
    @case (
      data.param === 'road_condition' ||
      data.param === 'road_condition2' ||
      data.param === 'road_condition3'
        ? data.param
        : ''
    ) {
      <td
        [ngClass]="
          data.dataset[data.param]
            | colorMappingCond: smwServiceGreenTableDesignValue
        ">
        {{
          'MAPPING.GMA_ROAD_CONDITION_SHORT.' + data.dataset[data.param]
            | translate
        }}
      </td>
    }
    @case (data.param === 'vis' || data.param === 'vv' ? data.param : '') {
      <td [ngClass]="data.param | colorMappingPigeon: data.dataset[data.param]">
        {{ data.dataset[data.param] ? data.dataset[data.param] / 1000 : '--' }}
      </td>
    }
    @case (
      data.param === 'tt' ||
      data.param.indexOf('road_tt') >= 0 ||
      data.param === 'tg0'
        ? data.param
        : ''
    ) {
      <td
        [ngClass]="
          data.dataset[data.param]
            | colorMappingTT: smwServiceGreenTableDesignValue
        ">
        {{ data.dataset[data.param] | number: '1.1-1' }}
      </td>
    }
    @case (data.param === 'td' ? data.param : '') {
      <td [ngClass]="data.param | colorMappingPigeon: data.dataset[data.param]">
        {{ data.dataset[data.param] | number: '1.1-1' }}
      </td>
    }
    @case (
      data.param === 'humidityIndex' || data.param === 'inversionIndex'
        ? data.param
        : ''
    ) {
      <td [ngClass]="data.param | colorMappingPigeon: data.dataset[data.param]">
        {{ data.dataset[data.param] }}
      </td>
    }
    @case ('rh') {
      <td>
        {{ data.dataset[data.param] | rh }}
      </td>
    }
    @case ('r_avail') {
      <td>
        <fa-icon
          [icon]="[
            'far',
            data.dataset[data.param] > 0 ? 'check' : 'minus',
          ]"></fa-icon>
      </td>
    }
    @case ('r_type') {
      <td>
        @let precipitationTypeMapping =
          data.dataset[data.param]
            | gmaPrecipitationTypeMapping: stationInfo().type;
        {{ precipitationTypeMapping | translate }}
      </td>
    }
    @case ('n') {
      <td>
        @if (data.dataset[data.param] | isNil: false) {
          <div
            class="table__svgWrapper"
            [matTooltip]="
              data.dataset[data.param] +
              '/8 ' +
              ('MAPPING.NE.' + data.dataset[data.param] | translate)
            ">
            <mat-icon
              [svgIcon]="'ne_' + (data.dataset[data.param] | round)"
              [matTooltip]="
                (data.dataset[data.param] | round) +
                '/8 ' +
                ('MAPPING.NE.' + data.dataset[data.param] | translate)
              ">
            </mat-icon>
            <!-- <img  height="18" src="/assets/symbols/N_TotalCloudCover/WeatherSymbol_WMO_TotalCloudCover_N_{{ data.dataset[data.param] }}.svg"> -->
          </div>
        } @else {
          --
        }
      </td>
    }
    @case ('ww') {
      <td>
        @let cleanedWW = data.dataset[data.param] | getCleanedWw;
        @if (cleanedWW > 39) {
          <img
            height="12"
            matTooltip="{{ 'MAPPING.WW.' + cleanedWW | translate }}"
            src="/assets/symbols/wm/ww/{{ cleanedWW }}.svg" />
        } @else {
          --
        }
      </td>
    }
    @default {
      <td>
        {{ data.dataset[data.param] | number: '1.1-1' }}
      </td>
    }
  }
</ng-template>
